import React from 'react';
import { useNavigate } from 'react-router-dom';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '95vh',
        width: '100vw',
        margin: 0,
        backgroundColor: '#f9fafb',
        color: '#333',
        textAlign: 'center',
    },
    heading: {
        fontSize: '6rem',
        fontWeight: '700',
        marginBottom: '1rem',
    },
    paragraph: {
        fontSize: '1.5rem',
        marginBottom: '2.5rem',
        color: '#555',
    },
    button: {
        padding: '1rem 2rem',
        backgroundColor: '#000',
        color: '#fff',
        border: 'none',
        borderRadius: '0.5rem',
        cursor: 'pointer',
        fontSize: '1.25rem',
        transition: 'background-color 0.3s ease',
    },
    buttonHover: {
        backgroundColor: '#222',
    },
};

const NotFound = () => {
    const navigate = useNavigate();
    const [hover, setHover] = React.useState(false);

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>404</h1>
            <p style={styles.paragraph}>Сторінку не знайдено</p>
            <button
                onClick={() => navigate('/')}
                style={hover ? { ...styles.button, ...styles.buttonHover } : styles.button}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                aria-label="Повернутися на головну"
            >
                Повернутися на головну
            </button>
        </div>
    );
};

export default NotFound;
